import React from 'react';
import Image from 'next/image';
import ConsultationBtn from '@/components/resume/resume-marketing/ConsultationBtn';
import reportImage from '@/assets/resume-consult/report.png';
import quizImage from '@/assets/resume-consult/quiz.png';
import offerImage from '@/assets/resume-consult/offer.png';
import figureImage from '@/assets/resume-consult/figure.png';

const ConsultClassify = (props: { isConsultationBtnLink?: boolean }) => {
  const { isConsultationBtnLink } = props;

  return (
    <div
      className="my-10 px-5 tablet:my-25"
      data-ele-id="content"
      data-ele-group="5th_screen"
      data-observer-id="5th_screen"
    >
      <div className="text-center">
        <p className="text-3xl font-semibold mb-4 tablet:text-4.5xl">
          专家一对一，打造专属于您的求职利器
        </p>
        <p className="text-lg mb-5 tablet:text-xl tablet:mb-10">
          专家深度交流，个性化指导，为您量身打造脱颖而出的简历
        </p>
        <ConsultationBtn
          isLink={isConsultationBtnLink}
          dataEleGroup="5th_screen"
        />
      </div>
      <div className="flex justify-center flex-col mt-8 tablet:flex-row">
        <div className="h-[360px] flex flex-col py-8 px-7.5 mb-10 rounded-xl bg-web-magenta-200 tablet:w-[550px] tablet:h-[600px] tablet:py-16 tablet:px-12.5 tablet:mr-10 tablet:mb-0 tablet:rounded-2.5xl">
          <div className="w-full mx-auto grow relative">
            <Image
              src={reportImage}
              alt=""
              fill
              style={{
                objectFit: 'contain',
              }}
            />
          </div>
          <p className="text-base text-center font-semibold mt-auto pt-10 tablet:text-2xl">
            量身定制的简历报告！
          </p>
        </div>
        <div className="h-[360px] flex flex-col py-8 px-7.5 rounded-xl bg-web-purple-200 tablet:w-[550px] tablet:h-[600px] tablet:py-16 tablet:px-12.5 tablet:rounded-2.5xl">
          <div className="w-full mx-auto grow relative">
            <Image
              src={quizImage}
              alt=""
              fill
              style={{
                objectFit: 'contain',
              }}
            />
          </div>
          <p className="text-base text-center font-semibold mt-auto pt-4 tablet:text-2xl">
            以职业规划为出发点，深度评测！
          </p>
        </div>
      </div>
      <div className="flex justify-center flex-col mt-10 tablet:flex-row">
        <div className="h-[360px] flex flex-col py-8 px-7.5 mb-10 rounded-xl bg-web-blue-300 tablet:w-[550px] tablet:h-[600px] tablet:py-16 tablet:px-12.5 tablet:mr-10 tablet:mb-0 tablet:rounded-2.5xl">
          <div className="w-full mx-auto grow relative">
            <Image
              src={offerImage}
              alt=""
              fill
              style={{
                objectFit: 'contain',
              }}
            />
          </div>
          <p className="text-base text-center font-semibold mt-auto pt-4 tablet:text-2xl">
            助力你拿到心仪offer！
          </p>
        </div>
        <div className="h-[360px] flex flex-col py-8 px-7.5 rounded-xl bg-web-aqua-200 tablet:w-[550px] tablet:h-[600px] tablet:py-16 tablet:px-12.5 tablet:rounded-2.5xl">
          <div className="w-full mx-auto grow relative">
            <Image
              src={figureImage}
              alt=""
              fill
              style={{
                objectFit: 'contain',
              }}
            />
          </div>
          <p className="text-base text-center font-semibold mt-auto pt-4 tablet:text-2xl">
            量身定制的简历报告！
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConsultClassify;
